import React from 'react'
import PropType from 'prop-types'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import BaseButton from './BaseButton'
import FabAdapter from './FabAdapter'

const ButtonAdapter = ({
  children, fullWidth, variant, onClick, className, disabled, type,
}) => {
  switch (variant) {
    case 'extended': return (
      <FabAdapter
        className={className}
        disabled={disabled}
        isExtended
        type={type}
        onClick={onClick}
      >
        { children }
      </FabAdapter>
    )
    case 'fab': return (
      <FabAdapter
        className={className}
        disabled={disabled}
        onClick={onClick}
        type={type}
      >
        { children }
      </FabAdapter>
    )
    case 'plain': return (
      <Button
        fullWidth={fullWidth}
        variant="contained"
        disabled={disabled}
        onClick={onClick}
        type={type}
      >
        { children }
      </Button>
    )
    case 'icon': return (
      <IconButton
        className={className}
        color="inherit"
        edge="start"
        onClick={onClick}
        type={type}
      >
        { children }
      </IconButton>
    )
    case 'outlined': return (
      <BaseButton
        fullWidth={fullWidth}
        variant={variant}
        className={className}
        onClick={onClick}
        type={type}
      >
        { children }
      </BaseButton>
    )
    case 'default':
    default: return (
      <BaseButton
        variant="text"
        className={className}
        disabled={disabled}
        fullWidth={fullWidth}
        onClick={onClick}
        type={type}
      >
        { children }
      </BaseButton>
    )
  }
}

ButtonAdapter.defaultProps = {
  children: null,
  className: '',
  disabled: false,
  fullWidth: false,
  onClick: () => null,
  variant: 'default',
  type: 'button',
}

ButtonAdapter.propTypes = {
  onClick: PropType.func,
  children: PropType.node,
  className: PropType.string,
  disabled: PropType.bool,
  fullWidth: PropType.bool,
  type: PropType.string,
  variant: PropType.oneOf(['default', 'plain', 'outlined', 'fab', 'extended', 'icon']),
}

export default ButtonAdapter
